interface VendorInvoiceDetailsProps {
  rowData: any;
}

export const VoidedInvoiceView: React.FC<VendorInvoiceDetailsProps> = ({
  rowData,
}) => {
  const getMaskedBankAccount = (
    bankAccount: string | undefined
  ): string | null => {
    return bankAccount ? bankAccount.replace(/.(?=.{4})/g, "x") : "N/A";
  };
  function formatDate(date) {
    if (!date) {
      return "N/A";
    }
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }
  const getDescription = (): string => {
    if (rowData?.length === 0) {
      return "Account#: N/A DUE N/A; Service N/A to N/A";
    }
    const autoPayDescription = rowData?.autoPayName
      ? rowData?.autoPayName?.toLowerCase() === "eft"
        ? getMaskedBankAccount(rowData?.bankAccount)
        : `AUTOPAY ${getMaskedBankAccount(rowData?.bankAccount)}`
      : "";

    const accountNumber = rowData?.accountNumber
      ? rowData?.accountNumber
      : "N/A";
    return `Account#: ${accountNumber} ${autoPayDescription} DUE ${formatDate(
      rowData?.duedate
    )}; Service date ${formatDate(rowData?.servicePeriodDate)} to ${formatDate(
      rowData?.billingPeriodEndDate
    )} `;
  };
  return (
    <>
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2">
          {/* Left fields */}
          <div className="p-2 divide-y m-2">
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <span className="text-red-500">*</span> Service No. Account:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.accountNumber}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <span className="text-red-500">*</span>Corporate Office Number:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.storeNumber}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Office Status:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeStatus}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Office Name:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeName}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Office Address:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeStreet} {", "} {rowData?.officeCity} {", "}
                {rowData?.officeStateCode} {rowData?.officeZipcode}
              </div>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeZipcode}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Confie Brand:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeBrand}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span> Amount Paid:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.amountPaid}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span> Billing Period Start
                  Date:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.servicePeriodDate
                  ? rowData?.servicePeriodDate &&
                    new Date(rowData?.servicePeriodDate).toLocaleDateString()
                  : ""}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <span className="text-red-500">*</span> Billing Period End Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.billingPeriodEndDate
                  ? rowData?.billingPeriodEndDate &&
                    new Date(rowData?.billingPeriodEndDate).toLocaleDateString()
                  : ""}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span>Invoice No.:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.invoiceNumber}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span>Date Capture:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.dateCapture
                  ? rowData?.dateCapture &&
                    new Date(rowData?.bankReferenceDate).toLocaleDateString()
                  : ""}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Bank Reference:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.bankReference}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Bank Reference Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.bankReferenceDate
                  ? rowData?.bankReferenceDate &&
                    new Date(rowData?.bankReferenceDate).toLocaleDateString()
                  : ""}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Expense Account:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.expenseAccountDescription}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">Auto Pay:</label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.autoPayName}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Description:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {getDescription()}
              </div>
            </div>
          </div>
          {/* Right fields */}
          <div className="p-2 divide-y">
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Vendor Name:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.vendorName}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Vendor ID:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.vendorCode}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Bank Account:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.bankAccount
                  ? rowData?.bankAccount.replace(/.(?=.{4})/g, "x")
                  : null}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Utility Type:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.utilityType}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Branch GL:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.branchGL}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Subaccounts:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.glsubaccounts}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span> Due Date:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.duedate
                  ? rowData?.duedate &&
                    new Date(rowData?.duedate).toLocaleDateString()
                  : ""}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                {rowData.previousBalance ? (
                  <div className="flex flex row">
                    <span className="text-red-500">*</span>Previous Balance
                    Amount:
                  </div>
                ) : (
                  "Previous Balance Amount:"
                )}
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData.previousBalanceAmount}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Draft Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData.draftDate}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Invoice Image:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.invoiceImageAttachment}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">Note:</label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.noteSection}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Created By:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.createdBy}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Created Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.createdDate
                  ? rowData?.createdDate &&
                    rowData?.createdDate.slice(0, 10) +
                      " " +
                      new Date(rowData?.createdDate).toLocaleTimeString(
                        navigator.language,
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )
                  : ""}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Modified By:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.modifiedBy}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Modified Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.modifiedDate
                  ? rowData?.modifiedDate &&
                    rowData?.modifiedDate.slice(0, 10) +
                      " " +
                      new Date(rowData?.modifiedDate).toLocaleTimeString(
                        navigator.language,
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
